<template>
    <div>
    </div>
</template>

<script>

export default {
    name: 'page-content',
    beforeMount () {
      if(!location.pathname.toLowerCase().startsWith('/rccl.')) {
        location.href = `${process.env.VUE_APP_BASE_URL}${location.pathname}${location.search}`
      }
    }
}
</script>
